module.exports = __webpack_public_path__ + "static/media/81680034-i0F0wSgs.b3e82dc9.JPG";